import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Activity, BookOpen, Wind } from 'lucide-react';
export const MechanismSection = () => {
  return <Section variant="navy" data-id="element-74">
      <FadeIn data-id="element-75">
        <div className="text-center mb-16" data-id="element-76">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-77">
            El Sistema de Triaje <span className="text-gold" data-id="element-78">SOS</span>
          </h2>
          <p className="text-xl text-cream-muted max-w-2xl mx-auto" data-id="element-79">
            A diferencia de un estudio bíblico tradicional, este método funciona
            como una farmacia espiritual.
          </p>
        </div>
      </FadeIn>

      <div className="relative max-w-4xl mx-auto" data-id="element-80">
        {/* Connecting line for desktop */}
        <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gold/20 -translate-y-1/2 z-0" data-id="element-81"></div>

        <div className="grid md:grid-cols-3 gap-8 relative z-10" data-id="element-82">
          <FadeIn delay={0.1} className="bg-navy-light p-8 rounded-2xl border border-gold/30 shadow-glow relative" data-id="element-83">
            <div className="w-14 h-14 bg-navy rounded-full flex items-center justify-center border border-gold/50 mx-auto mb-6 absolute -top-7 left-1/2 -translate-x-1/2" data-id="element-84">
              <Activity className="w-6 h-6 text-gold" data-id="element-85" />
            </div>
            <h3 className="text-xl font-bold text-center mb-4 mt-4 text-gold" data-id="element-86">
              Síntoma
            </h3>
            <p className="text-cream-muted text-center" data-id="element-87">
              Identificas el síntoma físico (taquicardia, insomnio, nudo en el
              pecho).
            </p>
          </FadeIn>

          <FadeIn delay={0.2} className="bg-navy-light p-8 rounded-2xl border border-gold/30 shadow-glow relative mt-8 md:mt-0" data-id="element-88">
            <div className="w-14 h-14 bg-navy rounded-full flex items-center justify-center border border-gold/50 mx-auto mb-6 absolute -top-7 left-1/2 -translate-x-1/2" data-id="element-89">
              <BookOpen className="w-6 h-6 text-gold" data-id="element-90" />
            </div>
            <h3 className="text-xl font-bold text-center mb-4 mt-4 text-gold" data-id="element-91">
              Obra
            </h3>
            <p className="text-cream-muted text-center" data-id="element-92">
              Aplicas el código bíblico específico del "Manual del Fabricante".
            </p>
          </FadeIn>

          <FadeIn delay={0.3} className="bg-navy-light p-8 rounded-2xl border border-gold/30 shadow-glow relative mt-8 md:mt-0" data-id="element-93">
            <div className="w-14 h-14 bg-navy rounded-full flex items-center justify-center border border-gold/50 mx-auto mb-6 absolute -top-7 left-1/2 -translate-x-1/2" data-id="element-94">
              <Wind className="w-6 h-6 text-gold" data-id="element-95" />
            </div>
            <h3 className="text-xl font-bold text-center mb-4 mt-4 text-gold" data-id="element-96">
              Silencio
            </h3>
            <p className="text-cream-muted text-center" data-id="element-97">
              Desactivas la alerta del sistema nervioso de forma mecánica y
              espiritual.
            </p>
          </FadeIn>
        </div>
      </div>
    </Section>;
};